import React from 'react'
import { useFloor } from '@providers/mapProvider'
import { AssignmentSelect } from './components/AssignmentSelect'
import SelectWrapper from '../SelectWrapper/SelectWrapper'
import clearableSelectCss from '@ui/selects/clearableSelectWrapper.module.scss'
import { IFloorMapSpace, ISpaceDetails, IUsageType } from '@api'
import { SpaceInfo } from './components/SpaceInfo'
import useSpaceDetails from 'components/AdminFloorPlan/hooks/useSpaceDetails'
import { get } from 'lodash'
import { isNeighborhood, isShared } from '@utils'
import EmployeeList from './components/EmployeeList/EmployeeList'
import { Typography, Button } from '@runeffective/evo-design-system'
import css from './components/EmployeeList/EmployeeList.module.scss'
import { Flex, Icon } from '@ui'

import { navigate } from '@reach/router'

const AssignedTab = () => {
  const floor = useFloor()
  const selectedSpaceId = get(floor, 'selection.selectedSpacesList[0]', '')
  const {
    data: { space },
    updateData,
  } = useSpaceDetails(selectedSpaceId)

  const updateEmployee = (spaces: IFloorMapSpace[]) => {
    updateData(spaces[0])
  }

  if (!floor.floorId) return null

  if (!space?.spaceAssignment?.employee) {
    return (
      <>
        <SelectWrapper title="Assign">
          <div className={clearableSelectCss.clearable_select_wrapper}>
            <AssignmentSelect
              assignmentPlanId={floor.apId}
              space={space as IFloorMapSpace}
              onChange={(spaces: IFloorMapSpace[]) => updateEmployee(spaces)}
            />
          </div>
        </SelectWrapper>
        {(space?.spaceAssignment?.sharedEmployees ||
          (space?.spaceAssignment?.neighborhood?.employees?.length as number) > 0) &&
          (isShared(space?.usageType as IUsageType) ||
            isNeighborhood(space?.usageType as IUsageType)) && (
            <>
              <Flex style={{ margin: '10px 25px 10px 0px' }} justify="space-between">
                <div style={{ marginTop: '5px' }}>
                  <Typography className={css.empDeptClass} token="body-small-01">
                    {isShared(space?.usageType as IUsageType)
                      ? space?.spaceAssignment?.sharedEmployees?.length
                      : space?.spaceAssignment?.neighborhood?.employees?.length}{' '}
                    Employees
                  </Typography>
                </div>
                {isNeighborhood(space?.usageType as IUsageType) && (
                  <Button
                    layout="borderless"
                    size="small"
                    startIcon={<Icon name="gear" />}
                    onClick={() =>
                      navigate(
                        `?neighborhoodId=${space?.spaceAssignment?.neighborhood?.id as string}`
                      )
                    }
                  >
                    Manage
                  </Button>
                )}
              </Flex>
              <EmployeeList
                updateData={(space: ISpaceDetails) => updateData(space)}
                assignmentPlanId={floor.apId}
                floorHook={floor}
                space={space as IFloorMapSpace}
              />
            </>
          )}
      </>
    )
  }

  return (
    <SpaceInfo
      space={space}
      assignedEmployee={space?.spaceAssignment?.employee}
      updateData={(space: ISpaceDetails) => updateData(space)}
      assignmentPlanId={floor.apId}
    />
  )
}

export default AssignedTab
